import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {LossList} from "./components/LossList";

export const Loss = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.loss')}`}
                         content={<LossList/>}/>
}